import axios from 'axios';

// Base URL (no /api here — we add it in axios)
const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://api.sanga.sangabiz.com';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response || error);
    return Promise.reject(error);
  }
);

// Helper: handle DRF pagination
const extractResults = (data) => {
  if (data && typeof data === 'object' && Array.isArray(data.results)) {
    return data.results;
  }
  if (Array.isArray(data)) {
    return data;
  }
  return [];
};

// -------------------- API FUNCTIONS --------------------

export const getSkills = async () => {
  const res = await api.get('/skills/');
  return { data: extractResults(res.data) };
};

export const getProjects = async () => {
  const res = await api.get('/projects/');
  return { data: extractResults(res.data) };
};

export const getProject = async (slug) => {
  const res = await api.get(`/projects/${slug}/`);
  return { data: res.data };
};

export const getServices = async () => {
  const res = await api.get('/services/');
  return { data: extractResults(res.data) };
};

export const getEducation = async () => {
  const res = await api.get('/education/');
  return { data: extractResults(res.data) };
};

export const getCertifications = async () => {
  const res = await api.get('/certifications/');
  return { data: extractResults(res.data) };
};

export const getStats = async () => {
  const res = await api.get('/stats/');
  return { data: res.data || {} };
};

export const submitContact = async (data) => {
  const res = await api.post('/contact/', data);
  return res.data;
};

export default api;
